import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors, calculateSpacing } from '@vds/theme';
import { IconData } from '@vds/icons';
import { DropdownSelect as CoreDropdownSelect } from '@vds-core/selects';
import { BodyConfig, Body, Micro, TypographyConfig } from '@vds/typography';
import { Tooltip } from '@vds/tooltips';
var propTypes = {
  required: PropTypes.bool,

  /**
   * If true, the label will be displayed inside the dropdown container. Otherwise, the label will be above the dropdown container like a normal text input.
   */
  inlineLabel: PropTypes.bool,

  /**
   * String, array or node containing the title of the TooltipDialog
   */
  tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * String, array or node containing the body content of the TooltipDialog
   */
  tooltipContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.node]),

  /**
   * If provided, will contain the string for the helper text
   */
  helperText: PropTypes.string,

  /**
   * Determines the placement of the helper text (right or bottom)
   */
  helperTextPlacement: PropTypes.oneOf(['right', 'bottom'])
};
var defaultProps = {
  required: true,
  helperTextPlacement: 'bottom',
  inlineLabel: false
};

var DropdownSelect = function DropdownSelect(props) {
  var required = props.required,
      inlineLabel = props.inlineLabel,
      helperText = props.helperText,
      helperTextPlacement = props.helperTextPlacement,
      tooltipTitle = props.tooltipTitle,
      tooltipContent = props.tooltipContent;
  return /*#__PURE__*/React.createElement(CoreDropdownSelect, _extends({}, props, {
    readOnlyBorders: true,
    hoverState: true,
    focusState: true,
    inputFontSize: true,
    overflowEllipsis: true,
    typescale: TypographyConfig.getTypescale(),
    minWidth: inlineLabel ? '110px' : '66px',
    maxWidth: "604px",
    height: calculateRem(44),
    selectPadding: calculateRem(12, 44, 12, 12),
    labelMarginBottom: calculateSpacing('1X'),
    errorLabelSpacing: calculateSpacing('2X'),
    iconConfig: IconData,
    color: colors,
    required: required,
    bodyConfig: BodyConfig,
    helperText: helperText,
    helperTextPlacement: helperTextPlacement,
    Tooltip: Tooltip,
    tooltipTitle: tooltipTitle,
    tooltipContent: tooltipContent,
    Body: Body,
    Micro: Micro
  }));
};

DropdownSelect.propTypes = propTypes;
DropdownSelect.defaultProps = defaultProps;
export default DropdownSelect;